import Vue from 'vue'
import config from '../appConfig';

Vue.filter('filePath', (filePath) => {
  if(filePath === null || !filePath.length) return null;
  return config.imgUrl + filePath;
});